const scrollDownBtn = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const scrollDownBtn = document.getElementById("scroll-down-btn");
    if (scrollDownBtn) {
      // Show the button only if the scroll is less than 50px
      window.addEventListener("scroll", () => {
        if (window.scrollY < 50) {
          scrollDownBtn.classList.add("visible");
        } else {
          scrollDownBtn.classList.remove("visible");
        }
      });

      // Scroll down 100vh when the button is clicked
      scrollDownBtn.addEventListener("click", () => {
        window.scrollBy({
          top: window.innerHeight,
          behavior: "smooth",
        });
      });
    }
  });
};

export default scrollDownBtn;
